<template>
  <div class="loading-frame" v-show="$store.state.LOADING">
    <!-- <div v-bind:style="styles" class="spinner spinner--wave">
      <div></div>
      <div></div>
      <div></div>
    </div> -->
    <div class="spinner">
      <div class="bounce1"></div>
      <div class="bounce2"></div>
      <div class="bounce3"></div>
    </div>
    <div class="letter">
      <span>数据加载中请耐心等候</span>
    </div>
    <!-- <div class="bgstyle">
      <van-loading size="24px" color="white" />
      <span>数据加载中请耐心等候</span>
    </div> -->
  </div>
</template>
<script>
export default {
  props: {
    size: {
      default: "40px"
    }
  },
  computed: {
    styles() {
      return {
        width: this.size,
        height: this.size
      };
    }
  }
};
</script>
<style lang="less" scoped>
// .loading-frame {
//   width: 100%;
//   height: 100%;
//   position: fixed;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   background-color: rgba(255, 255, 255, 0.9);
//   z-index: 99999;
//   .spinner{

//     * {
//       line-height: 0;
//       box-sizing: border-box;
//     }
//   }
//   .spinner > div {
//     background-color: transparent;
//     border: 5px solid #2185d7;
//     border-radius: 100%;
//     animation-fill-mode: both;
//     position: absolute;
//     opacity: 0;
//     width: 50px;
//     height: 50px;
//     animation: wave-jumper 1s 0s linear infinite;
//   }
//   .spinner > div:nth-child(2) {
//     animation-delay: 0.33333s;
//   }
//   .spinner > div:nth-child(3) {
//     animation-delay: 0.66666s;
//   }

//   @keyframes wave-jumper {
//     0% {
//       opacity: 0;
//       transform: scale(0);
//     }
//     5% {
//       opacity: 1;
//     }
//     100% {
//       opacity: 0;
//     }
//   }
//   .bgstyle{
//     width: 120px;
//     height: 120px;
//     // background: rgba(153, 153, 153);
//     background: rgba(0, 0, 0, 0.8);
//     border-radius: 10px;
//     display: flex;
//     flex-flow: column nowrap;
//     justify-content: center;
//     align-items: center;
//     // color: #78c7ff;
//     color: white;
//     >span{
//       margin-top: 16px;
//     }
//   }
// }

.loading-frame {
  background-color: rgba(255, 255, 255, 0.9);
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  // margin-top: -44px;
}
.letter{
  >span{
    font-size: 16px;
    letter-spacing: 1px;
  }
}
/* 加载动画 */
.spinner {
  margin-top: 210px;
  // width: 70px;
  // text-align: center;
  font-size: 15px;
}

.spinner div {
  width: 18px;
  height: 18px;
  background:#5bb8ff;
  // background: linear-gradient(90deg, #ff7c33 0%, #ff4740 100%);
  
  border-radius: 100%;
  display: inline-block;
  -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
  animation: sk-bouncedelay 1.4s infinite ease-in-out both;
}

.spinner .bounce1 {
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}

.spinner .bounce2 {
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}

@-webkit-keyframes sk-bouncedelay {
  0%, 80%, 100% { -webkit-transform: scale(0) }
  40% { -webkit-transform: scale(1.0) }
}

@keyframes sk-bouncedelay {
  0%, 80%, 100% {
    -webkit-transform: scale(0);
    transform: scale(0);
  } 40% {
    -webkit-transform: scale(1.0);
    transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Loading/Loading.vue